import { Drawer } from "@components";
import { Titles } from "../../variables/Titles";

import DateForm from "../types/DateForm";

export const CustomerDateAndHourForm = ({
  visible,
  onClose,
  node,
  onChange,
  onSave,
  onRemove,
}) => {
  const input_configs = {
    mask: "99/99/9999 99:99",
    placeholder: "DD/MM/YYYY HH:mm",
    format: "DD/MM/YYYY HH:mm",
  };

  return (
    <Drawer
      visible={visible}
      onClose={() => onClose()}
      title={Titles.CustomerDateAndHour}
      direction="center-right"
      parentSelector={() => document.getElementById("oracle-flow")}
    >
      <DateForm
        node={node}
        input_configs={input_configs}
        onSave={(node) => onSave(node)}
        onRemove={onRemove}
      />
    </Drawer>
  );
};
